import React from 'react';
import PropTypes from 'prop-types';
import styled from 'react-emotion';
import ContentWrapper from '../components/content-wrapper';
import Result from '../components/result';
import TabGroup, {
  PictureSection,
  TablePanel,
  TitledSection,
} from '../components/tab-group';
import { connect } from 'react-redux';
import {
  translateFaceDiagnosisResult,
  translateTongueDiagnosisResult,
} from '../sagas/util';
import MusicPlayer from '../components/music-player';
import { changeTitle, queryObject } from '../util';

import DoctorAnnouncement from '../components/doctor-announcement';
import { replace } from 'connected-react-router';
import HealthSymptoms from '../components/health-symptoms';
import ClassicPrescription2 from '../components/classic-prescription2';
import PictureGrid from '../components/picture-grid';
import { changeMusicPlayAction } from '../actions/music-player';
import ReportHeader from '../components/report-header';
import { Gap, GapPageBreaker } from '../components/gap';
import SectionHeader from '../components/section-header';
import UserInfo from '../components/user-info';
import SimpleTable from '../components/simple-table';
import Indicator from '../components/indicator';
import SymptomSummary from '../components/SymptomSummary';
import ReportFooter from '../components/report-footer';
import { TextContent, TitlelessTextContent } from '../components/text-content';
import ClassicScript from '../components/classic-script';

import rsyw from '../assets/img/rsyw_jdyf_icon@3x.png';
import msk from '../assets/img/msk.jpg';
import rsywMock from '../assets/img/rsyw-text-mock.png';
import qlpp from '../assets/img/qlpp_jdyf_icon@3x.png';
import qlppMock from '../assets/img/qlpp-text-mock.png';
import bandAd from '../assets/img/band-ad.jpeg';
import bandAdHeader from '../assets/img/band-ad-header.png';

const StretchableContentWrapper = styled(ContentWrapper)`
  min-height: 100%;
  height: auto;
  
  @media print {
    background: none;
  }
`;

const PictureGridWrapper = styled.div`
  margin: 0 auto 6px 80px;
  
  @media print {
    margin: 0 auto 6px 40px;
  }
`;

const VideoWrapper = styled.div`
  margin: 0px 40px;
  
  &.prism-fullscreen {
    margin: 0;
  }
`;
const Shelter = styled.div`
  width:150px;
  height:30px;
  position:relative;
  left:70px;
  top:46px;
  z-index:999;
  background:url(${msk});
  opacity:0.5;
  border:1px solid gray;
`;
class Report extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: 0,
    };
    this.healthKey = '健康';
  }

  componentWillMount() {
    // fixme dirty fix of refreshing on history report page
    const { props } = this;
    if (!props || !props.result || !props.result.examination) {
      const { id } = this.props;
      this.reloadReport(id);
    }
  }

  componentDidMount() {
    changeTitle('个人健康管理报告');
  }

  componentWillUpdate(newProps) {
    if (!newProps || !newProps.result || !newProps.result.examination) {
      if (newProps.id) this.reloadReport(newProps.id);
    }
  }

  getMusic({ solutions, symptoms }) {
    const symptom = (symptoms && symptoms.length > 0)
      ? symptoms[0].name
      : this.healthKey;
    const music = solutions.music[symptom];
    if (!music) return null;
    return {
      title: music.name.replace(/\..*$/, ''),
      url: `${solutions.asset_prefix}${music.asset}`,
    };
  }

  shoppingUrl() {
    const { source = '' } = queryObject();
    if (source === 'dhs') {
      return 'http://www.178yy.com/erji/hljdh/';
    }
    return 'http://www.zhiyuntcm.com/';
  }

  reloadReport(id) {
    const { dispatch } = this.props;

    if (id) {
      dispatch(replace(`/history/${id}`));
    }
  }

  renderSolutionElement(symptoms, element, render) {
    if (!symptoms || !symptoms.length) symptoms = [{ name: this.healthKey }];

    return symptoms.map(({ name }) => (
      element[name].content.map((e, idx) => (render(e, idx)))
    ));
  }

  renderPrinciples({ solutions, symptoms }) {
    const symptom = symptoms && symptoms.length ? symptoms[0].name : '健康';
    const { health_principle } = solutions;
    return (
      <TextContent>
        {health_principle[symptom].content}
      </TextContent>
    );
  }

  renderVideoTab({
    key, name, assetPrefix, element
  }) {
    if (!element || !element.asset || !element.asset.length) {
      return null;
    }
    const onMount = () => new window.Aliplayer({
      id: 'J_prismPlayer',
      width: '668px',
      autoplay: false,
      useH5Prism: true,
      // playsinline: false,
      preload: false,
      // x5_type: null,
      height: '362px',
      controlBarVisibility: 'always',

      cover: `${assetPrefix}${element.asset[0].replace(/\..*$/, '.jpg')}`,
      source: `${assetPrefix}${element.asset[0]}`,
    }, (player) => {
      player.on('pause', () => {
        if (document.querySelector('video')) {
          document.querySelector('video').controls = false;
        }
      });
      player.on('play', () => this.props.dispatch(changeMusicPlayAction(false)));
    });
    return (
      <TablePanel key={key} title={name} onMount={onMount} screenOnly>
          {/*<Shelter></Shelter>*/}
        <VideoWrapper className='prism-player' id='J_prismPlayer' />
      </TablePanel>
    );
  }

  renderTabAsset({
    assetPrefix, asset, fill, assetGrid, border, borderRadius,
  }) {
    if (asset && assetGrid) {
      return (
        <PictureGridWrapper>
          <PictureGrid assets={asset} assetPrefix={assetPrefix} />
        </PictureGridWrapper>
      );
    } else if (asset) {
      return (
        <PictureSection
          src={`${assetPrefix}${asset[0]}`}
          height='280px'
          borderRadius={borderRadius}
          border={border}
          fill={fill} />
      );
    }
    return null;
  }

  renderGuidanceTab() {
    const { solutions, symptoms } = this.props.result.examination;
    const symptom = symptoms && symptoms.length ? symptoms[0].name : '健康';
    const music = this.getMusic({ symptoms, solutions });
    const guidance = solutions.health_guidance[symptom];

    return (
      <TablePanel key='guidance' title='起居指导'>
        {music ? <MusicPlayer
          play={this.props.musicPlay}
          onPlayChange={next => this.props.dispatch(changeMusicPlayAction(next))}
          source={music}
        /> : null}
        <TitlelessTextContent>
          {!guidance ? null : guidance.content.join('')}
        </TitlelessTextContent>
      </TablePanel>
    );
  }

  renderTab({
    name, key, solutions, symptoms, fill = 'cover',
    subtitle1, subtitle2, assetTitle = null,
    assetGrid = false, titleBeforeAsset = false,
    picBorder = null, picBorderRadius = null,
  }) {
    const { asset_prefix: assetPrefix } = solutions;

    const element = solutions[key];
    const symptom = (symptoms && symptoms.length > 0)
      ? symptoms[0]
      : { name: this.healthKey };
    if (!element) return null;

    const e = element[symptom.name];

    if (key === 'video') {
      return this.renderVideoTab({
        element: e,
        key, name, assetPrefix,
      });
    } else if (key === 'health_guidance') {
      return this.renderGuidanceTab();
    }

    return (
      <TablePanel key={key} title={name}>
        { titleBeforeAsset ? <TitledSection title={e.name} /> : null }
        { assetTitle ? <TitledSection title={assetTitle} subtitle /> : null }
        {
          this.renderTabAsset({
            assetPrefix, asset: e.asset,
            fill, assetGrid, border: picBorder, borderRadius: picBorderRadius,
          })
        }
        { !titleBeforeAsset ? <TitledSection title={e.name} /> : null }
        {
          (e.content.length > 1) ?
            <TitledSection title={subtitle1} content={[e.content[0]]} subtitle /> :
            null
        }
        <TitledSection
          title={subtitle2}
          content={e.content.slice((e.content.length > 1) ? 1 : 0)}
          subtitle />
      </TablePanel>
    );
  }

  renderTabGroup({ symptoms, solutions }) {
    const group = [
      {
        name: '药膳调养',
        key: 'diet_therapy',
        subtitle1: '清单',
        subtitle2: '烹煮方法',
        assetTitle: '配料',
        assetGrid: true,
        titleBeforeAsset: true,
      },
      {
        name: '茶饮养生',
        key: 'herb_tea',
        picBorder: '1px solid #f0f0f0',
        picBorderRadius: '5px',
        subtitle1: '配料',
        subtitle2: '泡煮方法',
      },
      {
        name: '穴位按压',
        key: 'massage',
        picBorder: '1px solid #f0f0f0',
        picBorderRadius: '5px',
        fill: 'contain',
        subtitle1: '定位',
        subtitle2: '按摩方法',
      },
      {
        name: '起居指导',
        key: 'health_guidance',
      }
    ];
    return (
      <TabGroup
        active={this.state.activeTab}
        onTabChange={idx => this.setState({ activeTab: idx })}>
        {group.map(tab => this.renderTab({ ...tab, symptoms, solutions }))}
      </TabGroup>
    );
  }

  renderGaoFang(buttonText) {
    return [
      <SectionHeader key='a' title='人参燕窝膏' />,
      <ClassicScript
        key='b'
        to={this.shoppingUrl()}
        top={rsyw}
        bottom={rsywMock}
        buttonText={buttonText}
      />,
      <GapPageBreaker key='c' />,

      <SectionHeader key='d' title='秋梨枇杷膏' />,
      <ClassicScript
        key='e'
        to={this.shoppingUrl()}
        top={qlpp}
        bottom={qlppMock}
        buttonText={buttonText}
      />,
      <GapPageBreaker key='f' />,
    ];
  }

  render() {
    const { props } = this;
    if (!props || !props.result || !props.result.examination) {
      return null;
    }
    const { result } = this.props;
    const { examination } = result;
    if (!examination.symptoms || !examination.symptoms.length) {
      examination.symptoms = [{ name: this.healthKey }];
    }
    const { solutions, symptoms } = examination;

    const u = examination.user_info;
    const faceResult = translateFaceDiagnosisResult(result);
    const tongueResult = translateTongueDiagnosisResult(result);
    const { gf = '' } = queryObject();
    return (
      <StretchableContentWrapper>
        <ReportHeader displayTime={examination.display_time} />

        <Gap />

        { u ? <SectionHeader title='个人信息' /> : null}
        { u ? <UserInfo userinfo={u} /> : null}
        { u ? <Gap /> : null}

        <SectionHeader title='健康状态' />
        <Indicator score={examination.health_score} />
        <SymptomSummary
          score={examination.health_score}
          symptoms={examination.symptoms} />
        <GapPageBreaker />

        { gf === '1' ? this.renderGaoFang('点击购买') : null }

        <SectionHeader title='面诊结果' />
        <Result
          photo={examination.face_photo_url}
          iconStyle={{
            width: '66%',
          }}
          keys={['faceColor', 'faceGloss', 'lipColor']}
          keyNames={{
            faceColor: '面色',
            faceGloss: '光泽',
            lipColor: '唇色',
          }}
          values={faceResult}
          renderMore={() => [
            <SimpleTable
              key='face'
              columns={['面色', 'L值', 'A值', 'B值']}
              rows={[
                [faceResult.faceColor, faceResult.face_L, faceResult.face_a, faceResult.face_b],
              ]}
            />,
            <div key='gloss'>
              <SimpleTable
                columns={['光泽', '光泽指数']}
                rows={[
                [faceResult.faceGloss, faceResult.gloss_indicator.toFixed(2)],
              ]}
            />
            </div>,
            <SimpleTable
              key='lip'
              columns={['唇色', 'L值', 'A值', 'B值']}
              rows={[
                [faceResult.lipColor, faceResult.lip_L, faceResult.lip_a, faceResult.lip_b],
              ]}
            />,
          ]}
        />
        <Gap />

        <SectionHeader title='舌诊结果' />
        <Result
          photo={examination.tongue_photo_url}
          iconStyle={{
            width: '75%',
          }}
          keys={['tongueNatureColor', 'shape', 'tongueCoatColor', 'tongueCoatThickness']}
          keyNames={{
            tongueNatureColor: '舌色',
            shape: '舌形',
            tongueCoatColor: '苔色',
            tongueCoatThickness: '苔质',
          }}
          values={tongueResult}
          renderMore={() => [
            <SimpleTable
              key='nature'
              columns={['舌色', 'L值', 'A值', 'B值']}
              rows={[
                [tongueResult.tongueNatureColor,
                  tongueResult.nature_L, tongueResult.nature_a, tongueResult.nature_b],
              ]}
            />,
            <div key='crack'>
              <SimpleTable
                columns={['裂纹', '裂纹指数']}
                rows={[
                  [tongueResult.tongueCrack, tongueResult.crack],
                ]}
              />
            </div>,
            <SimpleTable
              key='coat'
              columns={['苔色', 'L值', 'A值', 'B值']}
              rows={[
                [tongueResult.tongueCoatColor,
                  tongueResult.coat_L, tongueResult.coat_a, tongueResult.coat_b],
              ]}
            />,
          ]}
        />
        <GapPageBreaker />

        <SectionHeader title='健康解读' />
        <HealthSymptoms
          examination={examination}
        />

        <Gap />
        <SectionHeader title='保健原则' />
        {this.renderPrinciples(examination)}
          { gf ? null
              :
              [ (!examination.solutions.prescription || examination.symptoms[0].name === '健康') ? null :
                  [
                      <SectionHeader title='经典药方' />,
                      <ClassicPrescription2
                          examination={examination}
                      />]]
          }
        { gf === '2' ? this.renderGaoFang('推荐膏方') : null }
        { gf === '2' ? [
          <SectionHeader key='a' title='穿戴手环' />,
          <ClassicScript
            key='b'
            to={this.shoppingUrl()}
            top={bandAdHeader}
            bottom={bandAd}
            buttonText='推荐手环'
          />,
          <GapPageBreaker key='c' />,
        ] : null}

        <DoctorAnnouncement />

        {this.renderTabGroup({
          solutions,
          symptoms,
        })}

      </StretchableContentWrapper>
    );
  }
}

Report.defaultProps = {
  id: null,
};

Report.propTypes = {
  result: PropTypes.object.isRequired,
  id: PropTypes.string,
  dispatch: PropTypes.func.isRequired,
  musicPlay: PropTypes.bool.isRequired,
};

const mapStatesToProps = (state, props) => ({
  result: props.id ? { examination: state.resultHistory.records[props.id] } : state.result,
  musicPlay: state.musicPlayer.play,
});


export default connect(mapStatesToProps)(Report);



// WEBPACK FOOTER //
// ./src/scene/report.jsx